/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SolarIcon from "../../../Common/Svgs/SolarIcon";
import CustomSwitch from "../../../Core/Components/CustomSwitch";
import getFormatedFloat from "../../../Utils/getFormatedFloat";
import PowerGridIcon from "../../../Common/Svgs/PowerGridIcon";
import { client } from "../../../Utils/axiosClient";
import { updateHub } from "../../../Redux/Slices/hubs.slice";
import { getHubDetailEnergyConsumption } from "../../../Redux/APIs/hubAPI";
import capitalize from "../../../Utils/capitalize";
import usePermission from "../../../Core/hooks/usePermission";
import { PERMISSIONS } from "../../Login/constants";

const getEnergyConsumed = (value) => {
  let total = 0;
  let solar = 0;
  let storage = 0;

  if (value) {
    total = value;
    solar = value / 2;
    storage = value / 2;
  }

  return { total, solar, storage };
};

const Card = ({ data, isLast }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const isDataOfSelectedHub = data?.hubId == id;

  const hasPermission = usePermission([
    PERMISSIONS.ENERGY_MANAGEMENT_MODIFY_ENERGY,
  ]);

  const { total, solar, storage } = getEnergyConsumed(data?.value);

  const getPercent = (current) => {
    return (parseFloat(current) / parseFloat(total)) * 100 || 0;
  };

  const handleSwitch = async () => {
    const payload = {
      loadId: +data.id,
      hubId: +data.hubId,
    };

    try {
      dispatch(updateHub({ key: "loading", value: true }));

      const response = await client.post(
        `${process.env.REACT_APP_API_URL}/hubs/update-on-off-status`,
        payload,
      );

      if (response.status === 200) {
        dispatch(getHubDetailEnergyConsumption({ hubId: data.hubId }));

        dispatch(
          updateHub({
            key: "detailsToastMessage",
            value: {
              visible: true,
              data: {
                title: "Status Updated!",
                description: `Status for ${capitalize(
                  data.name,
                )} updated successfully.`,
              },
            },
          }),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(updateHub({ key: "loading", value: false }));
    }
  };

  return (
    <div className={`flex-1 ${isLast ? "" : "border-r border-light-grey"}`}>
      <div className="p-6 bg-background-white">
        <div className="flex items-start justify-between">
          {hasPermission && (
            <div>
              <CustomSwitch
                checked={Boolean(data.status)}
                onChange={handleSwitch}
                disabled={!isDataOfSelectedHub}
              />

              <p className="mt-2 font-poppins text-base font-medium capitalize">
                {data?.name}
              </p>
            </div>
          )}

          {data?.name === "charging station" ? (
            <button
              type="button"
              className="py-3 px-4 h-11 rounded-md bg-primary-10 hover:bg-primary-20 font-poppins font-medium text-primary text-xs"
              onClick={() => navigate("/charging-station")}
            >
              Details
            </button>
          ) : null}
        </div>

        <p
          className="font-poppins text-2xl font-[200] text-dark-gray"
          style={{ marginTop: hasPermission ? "20px" : "0px" }}
        >
          <span className="font-semibold text-black">
            {isDataOfSelectedHub ? getFormatedFloat(total, 0) : "--"}
          </span>{" "}
          kWh
        </p>

        <p className="mt-2 font-aileron font-normal text-dark-gray text-xs">
          Energy Consumed
        </p>
      </div>

      <div className="bg-[#F1F1F1] px-6 py-4">
        <div className="flex items-center w-full gap-x-1 mt-[1px]">
          <div
            className="h-2 bg-light-blue rounded-full"
            style={{ width: "50%" }}
          />

          <div
            className="h-2 bg-yellow rounded-full"
            style={{ width: "50%" }}
          />

          <div className="h-2 bg-green rounded-full" style={{ width: "2%" }} />
        </div>

        <div className="mt-[17px] flex items-center">
          <img
            src="/assets/icons/hubs/energy-storage.svg"
            className="w-4 h-4"
            alt="energy-storage"
          />

          <p className="flex-1 ml-2 font-poppins text-xs font-medium">
            {isDataOfSelectedHub ? getFormatedFloat(storage, 0) : "--"} kWh
          </p>

          <p className="font-poppins font-light text-xs text-dark-gray">
            {getPercent(storage)}%
          </p>
        </div>

        <div className="mt-[9px] flex items-center">
          <SolarIcon size={16} />

          <p className="flex-1 ml-2 font-poppins text-xs font-medium">
            {isDataOfSelectedHub ? getFormatedFloat(solar, 0) : "--"} kWh
          </p>

          <p className="font-poppins font-light text-xs text-dark-gray">
            {getPercent(solar)}%
          </p>
        </div>

        <div className="mt-[9px] flex items-center">
          <PowerGridIcon size={16} />

          <p className="flex-1 ml-2 font-poppins text-xs font-medium">-- kWh</p>

          <p className="font-poppins font-light text-xs text-dark-gray">0%</p>
        </div>
      </div>
    </div>
  );
};

const EnergyConsumption = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const { hubDetailsEnergyConsumption } = useSelector((state) => state.hubs);

  const hasPermission = usePermission([
    PERMISSIONS.ENERGY_MANAGEMENT_MODIFY_SUPPLY,
  ]);

  const isDataOfSelectedHub =
    hubDetailsEnergyConsumption?.length &&
    hubDetailsEnergyConsumption[0]?.hubId == id;

  const getTotal = () => {
    if (!hubDetailsEnergyConsumption?.length) return 0;

    if (!isDataOfSelectedHub) return "--";

    const total = hubDetailsEnergyConsumption.reduce((acc, current) => {
      acc += parseFloat(current.value);
      return acc;
    }, 0);

    return getFormatedFloat(total || 0, 0);
  };

  return (
    <div className="bg-[#F1F1F1] rounded-md border border-light-grey">
      <div className="flex items-center justify-between px-6 pt-6">
        <div className="flex items-center gap-x-2">
          <img
            src="/assets/icons/hubs/energy-consumption.svg"
            className="w-5 h-5"
            alt="energy-consumption"
          />

          <p className="font-poppins text-base font-medium">
            Energy Consumption
          </p>
        </div>

        {hasPermission && (
          <button
            type="button"
            className="flex items-center gap-x-2 py-[11px] px-4 rounded-md bg-primary hover:bg-primary-50"
            onClick={() => navigate("/suppy-control-panel")}
          >
            <img
              src="/assets/icons/hubs/manage.svg"
              className="w-5 h-5"
              alt="manage"
            />

            <p className="font-poppins font-medium text-xs text-background-white">
              Manage
            </p>
          </button>
        )}
      </div>

      <div className="mt-8 flex items-center w-full px-6">
        <div>
          <p className="font-poppins text-2xl font-[200] text-dark-gray">
            <span className="font-semibold text-black">{getTotal()}</span> kWh
          </p>

          <p className="mt-2 font-aileron font-normal text-xs text-dark-gray">
            Total Energy Consumed
          </p>
        </div>

        <div className="ml-[144px] flex-1">
          <div className="flex items-center gap-x-1">
            <div style={{ width: "50%" }}>
              <p className="font-poppins text-xs font-light text-dark-gray">
                50%
              </p>

              <div className="h-2 rounded-full bg-yellow" />
            </div>

            <div style={{ width: "50%" }}>
              <p className="font-poppins text-xs font-light text-dark-gray">
                50%
              </p>

              <div className="h-2 rounded-full bg-light-blue" />
            </div>

            <div style={{ width: "1%" }}>
              <p className="font-poppins text-xs font-light text-dark-gray">
                0%
              </p>

              <div className="h-2 rounded-full bg-green" />
            </div>
          </div>

          <div className="mt-2 flex items-center justify-normal w-full">
            <div className="flex-1 flex items-center gap-x-2">
              <SolarIcon />

              <p className="flex-1 font-aileron text-xs font-normal text-dark-gray">
                Solar
              </p>

              <p className="font-poppins font-medium text-xs">
                {isDataOfSelectedHub
                  ? getFormatedFloat(getTotal() / 2, 0)
                  : "--"}{" "}
                kWh
              </p>
            </div>

            <div className="w-[1px] h-3 mx-4 bg-[#D1CFCF]" />

            <div className="flex-1 flex items-center gap-x-2">
              <img
                src="/assets/icons/hubs/energy-storage.svg"
                className="w-4 h-4"
                alt="energy-storage"
              />

              <p className="flex-1 font-aileron text-xs font-normal text-dark-gray">
                Storage
              </p>

              <p className="font-poppins font-medium text-xs">
                {isDataOfSelectedHub
                  ? getFormatedFloat(getTotal() / 2, 0)
                  : "--"}{" "}
                kWh
              </p>
            </div>

            <div className="w-[1px] h-3 mx-4 bg-[#D1CFCF]" />

            <div className="flex-1 flex items-center gap-x-2">
              <PowerGridIcon />

              <p className="flex-1 font-aileron text-xs font-normal text-dark-gray">
                Grid
              </p>

              <p className="font-poppins font-medium text-xs">--</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 flex border-t border-light-grey">
        {hubDetailsEnergyConsumption?.map((item, index) => {
          return (
            <Card
              key={item.id}
              data={item}
              isLast={hubDetailsEnergyConsumption?.length === index + 1}
            />
          );
        })}
      </div>
    </div>
  );
};

export default EnergyConsumption;
